import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";
import LoadingPage from "../LoadingPage";

interface AuthenticatedRouteProps {
  broadcasterOnly?: boolean;
}

const AuthenticatedBroadcasterRoute = ({
  broadcasterOnly,
}: AuthenticatedRouteProps) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation(); // Get the current URL path

  if (isLoading) {
    return <LoadingPage />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  const { isBroadcaster } = user;
  if (!isBroadcaster) {
    return <Navigate to="/home" replace state={{ from: location }} />; // Redirect non-broadcasters to home or another page
  }

  return <Outlet />;
};

export default AuthenticatedBroadcasterRoute;
